/* eslint-disable no-underscore-dangle */
import type { TransferMatePayment } from './types';

interface TransfermateInputs {
    name: string;
    value: string;
}

interface TransfermateFormData {
    ro: string;
    location: string;
    student_number: string;
    room_number_text: string;
    cu_id_number: string;
    vita_ref: string;
    __instalment_amount_price: string;
    __deposit_amount_price: string;
    __miscellaneous_amount_price: string;
    outstanding_amount: string;
    academic_year_text: string;
}

const transferMateAdapter = (data: TransferMatePayment): TransfermateFormData => ({
    ro: 'room_number_text,__instalment_amount_price,__deposit_amount_price,__miscellaneous_amount_price,cu_id_number,vita_ref',
    location: data.account_id,
    student_number: data.user_id,
    room_number_text: data.room,
    cu_id_number: data.vitaref,
    vita_ref: data.vitaref,
    __instalment_amount_price: String(data.amount_due),
    __deposit_amount_price: String(0),
    __miscellaneous_amount_price: String(0),
    outstanding_amount: String(data.amount_due),
    academic_year_text: data.year,
});

const createInputMap = (data: TransfermateFormData): TransfermateInputs[] => [
    { name: 'ro', value: data.ro },
    { name: 'location', value: data.location },
    { name: 'student_number', value: data.student_number },
    { name: 'room_number_text', value: data.room_number_text },
    { name: 'cu_id_number', value: data.cu_id_number },
    { name: 'vita_ref', value: data.vita_ref },
    { name: '__instalment_amount_price', value: data.__instalment_amount_price },
    { name: '__deposit_amount_price', value: data.__deposit_amount_price },
    { name: '__miscellaneous_amount_price', value: data.__miscellaneous_amount_price },
    { name: 'outstanding_amount', value: data.outstanding_amount },
    { name: 'academic_year_text', value: data.academic_year_text },
];

const createForm = (transferMateUrl: string, inputMap: TransfermateInputs[]) => {
    const form = document.createElement('form');
    form.action = transferMateUrl;
    form.method = 'post';
    form.hidden = true;

    inputMap.forEach(({ name, value }) => {
        const input = document.createElement('input');
        input.name = name;
        input.value = value as string;
        form.append(input);
    });

    return form;
};

export const transferMateRedirect = (data: TransferMatePayment) => {
    const formData = transferMateAdapter(data);
    const inputMap = createInputMap(formData);
    const form = createForm(data.url, inputMap);

    document.body.append(form);
    form.submit();
};
